import { FC } from 'react'
import BaseAvatar from 'common/Avatar/Avatar'
import Styles from './Avatar.module.scss'
import { AvatarProps } from './Types'
import { getInitials } from 'utils'

const Avatar: FC<React.PropsWithChildren<AvatarProps>> = ({ name, url, children }) => {
  return (
    <div>
      {children || (
        <BaseAvatar backgroundColor={Styles.grey20} label={getInitials(name)} title={name} url={url} size={24} />
      )}
    </div>
  )
}

export { Avatar }
